import type { RightResult, RouterOutputs } from '../types/TRPC';

export type PublisherInviteSummary = RightResult<
  RouterOutputs['listPublisherPendingInvites']
>['invites'][number];

export type PublisherInviteLanding = RightResult<
  RouterOutputs['getPublisherInviteLanding']
>;

export function getPublisherInviteStateLabel(
  state: PublisherInviteSummary['state'] | PublisherInviteLanding['state'],
) {
  switch (state) {
    case 'Pending':
      return 'Pending';
    case 'Accepted':
      return 'Accepted';
    case 'Declined':
      return 'Declined';
    case 'Revoked':
      return 'Revoked';
    case 'Expired':
      return 'Expired';
    case 'BlockedDeletedAccount':
      return 'Support Required';
    case 'Invalid':
      return 'Invalid';
  }
}

export function getPublisherInviteStateClasses(
  state: PublisherInviteSummary['state'] | PublisherInviteLanding['state'],
) {
  switch (state) {
    case 'Pending':
      return 'border-emerald-500/30 bg-emerald-500/10 text-emerald-300';
    case 'Accepted':
      return 'border-sky-500/30 bg-sky-500/10 text-sky-300';
    case 'Declined':
      return 'border-neutral-700 bg-neutral-800/80 text-neutral-300';
    case 'Revoked':
      return 'border-neutral-700 bg-neutral-800/80 text-neutral-300';
    case 'Expired':
      return 'border-amber-500/30 bg-amber-500/10 text-amber-300';
    case 'BlockedDeletedAccount':
      return 'border-rose-500/30 bg-rose-500/10 text-rose-300';
    case 'Invalid':
      return 'border-neutral-700 bg-neutral-800/80 text-neutral-300';
  }
}

export function canResendPublisherInvite(
  invite: Pick<PublisherInviteSummary, 'state'>,
) {
  return invite.state === 'Pending' || invite.state === 'Expired';
}
